import ConsumerPanel from './ConsumerPanel';

export default ConsumerPanel;
